import { createRequestActionTypes } from '../../helpers'

export const FETCH_GUIDE = createRequestActionTypes('GUIDE', 'GUIDE')
